import { put, take, call } from 'redux-saga/effects';
import { GET_EVENT_MENU_LEVELS_REQUEST } from './types';
import {
  getEventMenuLevelsSuccess,
  getEventMenuLevelsError,
} from '../../../reducers/eventsLevelMenuOptionsSlice';
import withLoading from '../../../sagas/loadingSaga';
import { getErrorMessage } from '../../../common/utils/getErrorMessage';

export default function* eventsLevelMenuOptionsSaga(api) {
  while (true) {
    yield take(GET_EVENT_MENU_LEVELS_REQUEST);
    yield* withLoading(function* () {
      yield call(getEventsLevelMenuOptions, api);
    });
  }
}

function* getEventsLevelMenuOptions(api) {
  try {
    const eventMenuLevelData = yield call(api.getEventsLevelOptions);
    yield put(
      getEventMenuLevelsSuccess({
        eventMenuLevelData: eventMenuLevelData.data,
      }),
    );
  } catch (error) {
    yield put(getEventMenuLevelsError(getErrorMessage(error)));
  }
}
